import { render, staticRenderFns } from "./NoTemplateIcon.vue?vue&type=template&id=56ecdbab&"
import script from "./NoTemplateIcon.vue?vue&type=script&lang=js&"
export * from "./NoTemplateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports